import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { propTypes as i18nPropTypes } from '../../hocs/intlEquipped';
import Alert, { severityTypes } from '../Alert';
import SlideIn from '../Transitions/SlideIn';
import { useBffApi } from '../../hooks/useBffApi';

const DeviationNotifications = ({
    theme,
    subscriptionId,
    className,
    i18n: { formatMessage },
}) => {
    const [deviations, getDeviations] = useBffApi({
        path: `/subscriptions/${subscriptionId}/deviations`,
        options: {
            method: 'GET',
        },
        cache: true,
    });

    useEffect(() => {
        getDeviations();
    }, []);

    const { data, success } = deviations;

    const availableDeviationCodes = [
        'DELAYED',
        'DELIVERED_TO_MAIN_ENTRANCE',
        'GENERIC',
        'INCOMPLETE_ADDRESS',
        'NOT_DELIVERED',
        'WEATHER_CONDITIONS',
    ];

    return success && (
        <div
            data-testid="deviation-notifications-container"
            className={ classnames(theme.deviationNotifications, { [className]: !!className }) }
        >
            {data.deviations
                .filter(deviation => availableDeviationCodes.includes(deviation.code))
                .map(({ code, fromDate }) => (
                    <SlideIn key={ `${code}-${fromDate}` }>
                        <Alert
                            severity={ severityTypes.INFO }
                            className={ theme.alert }
                        >
                            {formatMessage(`subscription.deviations.${code}`)}
                        </Alert>
                    </SlideIn>
                ))}
        </div>
    );
};

DeviationNotifications.propTypes = {
    theme: PropTypes.shape({}),
    subscriptionId: PropTypes.string.isRequired,
    className: PropTypes.string,
    i18n: i18nPropTypes,
};

export default DeviationNotifications;
